import { executeRequest, Request } from '@jfs/network'
import { sendPaymentLinkParser } from '../network/parsers/SendPaymentLinkParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = sendPaymentLinkParser(data)
  return respData
}

const resendPaymentLinkRequest = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.sendPaymentLink,
    method: 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { resendPaymentLinkRequest }
